import React, { useMemo, useState } from "react";

const ChatImage = ({ name }) => {
  const [failed, setFailed] = useState(false);
  const src = useMemo(() => {
    const base = String(name || "").trim();
    if (!/^chat-\d+-[a-f0-9]+\.jpg$/i.test(base)) return "";
    return `/api/support/file/${encodeURIComponent(base)}`;
  }, [name]);

  if (!src || failed) return null;
  return (
    <img
      className="chat-pic"
      src={src}
      alt=""
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
};

export default ChatImage;
